// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3Ch-N","primary":"Button_primary__uZnPP","default":"Button_default__O9gX6"};